<template>
	<div id="outer">
		<p style="font-size: 40px;">Rooms</p>
		<div id="rooms_list">
			<div class="room_item" v-for="room in rooms" :key="room.name">
				<span style="display: flex;">
					<p style="flex: 1; text-align: left; word-break: break-all">
						{{room.name}}: {{room.player_amount}} Player(s)
					</p>
					<button @click="join_room(room.name)">
						{{ room.playing ? "Spectate" : "Join" }}
					</button>
				</span>
			</div>
			<div class="room_item"> 
				<span style="display: flex;">
					<input
						v-model="new_room_name"
						placeholder="Input room name"
						style="flex: 1; min-width: 0;"
						@keydown.enter="join_room(new_room_name)"
					>
					<button @click="join_room(new_room_name)">Join</button>
				</span>
			</div>
		</div>
	</div>
</template>

<style scoped>
#outer {
	margin: 10px;
	position: relative;
	flex: 1;
	border-radius: 10px;
	box-shadow: 0px 0px 10px var(--shadow_color);
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	text-align: center;
	align-content: center;
}

#outer * {
	font-size: 20px;
	margin: 4px 4px 4px 4px;
}

#rooms_list {
	width: 60%;
	margin-left: auto;
	margin-right: auto;
}

.room_item {
	margin-left: auto !important;
	margin-right: auto !important;
	width: 100%;
	box-shadow: 0px 0px 2px;
	display: inline-block;
}

.room_item * {
	display: inline-block;
}
</style>

<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
	data() {
		return {
			new_room_name: ""
		}
	},
	methods: {
		join_room: function(room_name) {
			var obj = [
				"join_room",
				{
					room_name
				}
			];
			this.$store.state.connection.send(JSON.stringify(obj));
		}
	},
	computed: {
		rooms () {
			var data = this.$store.state.game_data;
			if (data == null || data.type != "NotInRoom") return [];
			var ret = [...data.rooms];
			ret.sort((l, r) => r.player_amount - l.player_amount);
			return ret;
		}
	}
})
</script>
